<template>
  <div class="AboutInstructor">
    <div class="box">
      <h5 class="isintroduced">软件介绍</h5>
      <p class="frame" align="left">
        {{ itemsa.rjxz.rjjj }}
      </p>
      <h5 class="download">软件下载</h5>
      <img
        v-if="itemsa.rjxz.bhrjbb.length === 0"
        src="../../assets/Thereare.png"
        alt=""
      />
      <div
        class="softwareframe"
        v-for="item in itemsa.rjxz.bhrjbb"
        :key="item.id"
      >
        <img src="../../assets/logo.png" alt="" />
        <div class="ameofthe">
          <p align="left" class="text1">中医管理平台{{ item.ptxz }}端</p>

          <p align="left" class="text3">当前版本号{{ item.rhbb }}版</p>
        </div>
        <a v-if="item.ptxz === 'pc' || item.ptxz === 'VR'">
          <button class="Download">
            <a
              :href="http + item.wjsc"
              class="aisd"
              v-if="item.ptxz === 'pc' || item.ptxz === 'VR'"
            >
              立即下载
            </a>
          </button>
        </a>
        <button
          v-if="item.ptxz === 'ios' || item.ptxz === 'Android'"
          class="Download"
        >
          立即下载
        </button>
        <div
          class="Downloadbox"
          v-if="item.ptxz === 'ios' || item.ptxz === 'Android'"
        >
          <img class="imgss" :src="http + item.wjsc" alt="" />
          <p class="Downl">扫码下载</p>
        </div>

        <el-dialog
          v-if="item.ptxz === '网页'"
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose"
        >
          <span>{{ http + item.wjsc }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
          </span>
        </el-dialog>
        <button
          v-if="item.ptxz === '网页'"
          @click="dialogVisible = true"
          class="Download"
        >
          立即下载
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { selitem } from "../../api/patient";
// import Bus from '@/utils/bus'
export default {
  data() {
    return {
      itemsa: {
        gm: "",
        id: "",
        itemtime: "",
        jg: "",
        jsjs: "",
        kcjs: "",
        ll: "",
        name: "",
        pf: "",
        plcyrs: "",
        plts: "",
        rjxz: {
          bhrjbb: [],
          id: "",
          rjjj: "",
          rjlb: "",
          rjmc: "",
          rjsm: "",
          rjsm1: "",
          rjsp: "",
          rjsp1: "",
          rjtb: "",
          rjtb1: "",
          softwaretime: "",
        },
        sc: "",
        scrq: "",
        softwareid: "",
        sort: "",
        sp: "",
        sp1: "",
        status: "",
        tsy: "",
        userid: "",
        xj: "",
      },
      dialogVisible: false,
      tepform: "",
      http: this.$store.state.https,
      thisa: "",
    };
  },
  mounted() {
    if (this.$store.state.isLogin) {
    } else {
      this.$router.push("/SoftwareDownloading");
      this.$message({
        showClose: true,
        message: "请先进行登录",
        type: "warning",
      });
    }
    // Bus.$emit('activeIndexss', '/AboutInstructor')
  },
  created() {
    this.selitemid();
    // this.itemsa.rjxz.rjjj = ''
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    selitemid() {
      setTimeout(() => {
        const data = new FormData();
        data.append("id", this.$store.state.Jumpid);
        // alert()
        selitem(data).then((res) => {
          this.itemsa = res;
        });
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.AboutInstructor {
  width: 100%;
  .box {
    margin: 0 auto;
    width: 687px;
  }
}
.frame {
  text-indent: 30px;
  width: 687px;
  // height: 89px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
}
.isintroduced {
  text-align: left;
  margin-top: 25px;
  margin-bottom: 19px;
  // width: 56px;/
  padding-left: 10px;
  border-left: 2px solid #4ccaff;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
}
.download {
  margin-top: 29px;
  padding-left: 10px;
  margin-bottom: 20px;
  border-left: 2px solid #4ccaff;
  // width: 56px;
  text-align: left;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
}
.softwareframe {
  position: relative;
  margin-left: 10px;
  width: 675px;
  background: #ffffff;
  border: 1px solid #ececec;
  border-radius: 6px;
  display: flex;
  margin-bottom: 9px;
  img {
    margin-left: 31px;
    margin-top: 28px;
    width: 77px;
    height: 77px;
  }
  .ameofthe {
    display: flex;
    flex-direction: column;
    margin-left: 21px;
    width: 200px;
  }
}
.text1 {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  margin-top: 40px;
}
.text2 {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  margin-top: 2px;
}
.text3 {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  margin-top: 8px;
}
.Download {
  width: 110px;
  height: 35px;
  background: #f8f8f8;
  // border-radius: 18px;
  border: 0px;
  outline: none;
  margin-top: 45px;
  margin-left: 200px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4ccaff;
  a {
    color: #4ccaff;
  }
  a:hover {
    color: #4ccaff;
  }
}
.Downloadbox {
  display: none;
}
.Download:hover + .Downloadbox {
  display: block;
  width: 102px;
  height: 111px;
  position: absolute;
  top: 85px;
  right: 40px;
  background: #fff;
  // z-index:10;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.17);
  border-radius: 6px;
  z-index: 11111111111111;
  .imgss {
    margin: 0px;
    margin-top: 10px;
    width: 72px;
    height: 72px;
  }
  .Downl {
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
  }
}
// 适配手机端
@media (max-width: 768px) {
  .AboutInstructor {
    width: 100%;
    .box {
      margin-left: 10px;
      width: 100vw;
      img {
        width: 100vw;
      }
    }
  }
  .frame {
    width: 100vw;
  }
  .isintroduced {
    text-align: left;
    margin-top: 25px;
    margin-bottom: 19px;
    // width: 56px;/
    padding-left: 10px;
    border-left: 2px solid #4ccaff;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  .download {
    margin-top: 29px;
    padding-left: 10px;
    margin-bottom: 20px;
    border-left: 2px solid #4ccaff;
    // width: 56px;
    text-align: left;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  .softwareframe {
    position: relative;
    margin-left: 10px;
    width: 675px;
    background: #ffffff;
    border: 1px solid #ececec;
    border-radius: 6px;
    display: flex;
    margin-bottom: 9px;
    img {
      margin-left: 31px;
      margin-top: 28px;
      width: 77px;
      height: 77px;
    }
    .ameofthe {
      display: flex;
      flex-direction: column;
      margin-left: 21px;
      width: 200px;
    }
  }
  .text1 {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    margin-top: 40px;
  }
  .text2 {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    margin-top: 2px;
  }
  .text3 {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    margin-top: 8px;
  }
  .Download {
    width: 110px;
    height: 35px;
    background: #f8f8f8;
    // border-radius: 18px;
    border: 0px;
    outline: none;
    margin-top: 45px;
    margin-left: 200px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
    a {
      color: #4ccaff;
    }
    a:hover {
      color: #4ccaff;
    }
  }
  .Downloadbox {
    display: none;
  }
  .Download:hover + .Downloadbox {
    display: block;
    width: 102px;
    height: 111px;
    position: absolute;
    top: 85px;
    right: 40px;
    background: #fff;
    // z-index:10;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.17);
    border-radius: 6px;
    z-index: 11111111111111;
    .imgss {
      margin: 0px;
      margin-top: 10px;
      width: 72px;
      height: 72px;
    }
    .Downl {
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
    }
  }
}
</style>
